import { request, toQuery } from './client';
import type { PaginatedMeta, PaginationParams } from './client';

export type ProgramCategory = {
	id: number;
	name: string;
	slug: string;
	description: string;
	count: number;
	parent: number;
};

export type ProgramCategoriesListResponse = PaginatedMeta & {
	program_categories: ProgramCategory[];
};

export type CreateProgramCategoryData = {
	name: string;
	slug?: string;
	description?: string;
	parent?: number;
};

export type UpdateProgramCategoryData = Partial<CreateProgramCategoryData>;

export const programCategoriesApi = {
	list: (params?: PaginationParams) =>
		request<ProgramCategoriesListResponse>(
			'/program-categories' + toQuery(params),
		),

	get: (id: number) =>
		request<ProgramCategory>(`/program-categories/${id}`),

	create: (data: CreateProgramCategoryData) =>
		request<ProgramCategory>('/program-categories', {
			method: 'POST',
			data,
		}),

	update: (id: number, data: UpdateProgramCategoryData) =>
		request<ProgramCategory>(`/program-categories/${id}`, {
			method: 'POST',
			data,
		}),

	delete: (id: number) =>
		request<{ deleted: boolean; id: number }>(`/program-categories/${id}`, {
			method: 'DELETE',
		}),
};
